module.exports = __webpack_public_path__ + "static/media/ic-streaming-mic-off.cd723735.svg";